// vue-router中提供3种的路由模式
import { createWebHistory, createRouter } from 'vue-router'
let ismobi = false
const routes = [
  {
    path: '/',
    component: () => import('./page/home.vue'),
  },
  {
    path: '/home10',
    component: () => import('./page/home10.vue'),
  },
  {
    path: '/homeMore',
    name: 'homeMore',
    component: () => import('./page/homeMore.vue'),
  },
  {
    path: "/adult",
    name: 'adult',
    component: () => import('./page/adult.vue')
  },
  {
    path: "/search",
    name:'search',
    component: () => import('./page/search.vue')
  },
  {
    path: '/about',
    component: () => import('./page/about.vue')

  },
  {
    path: '/details',
    name: 'details',
    component: () => import('./page/details.vue'),
    meta: {
      keepAlive: true // 需要缓存
    }
  },
  {
    path: "/:patchAll(\\S+)",
    redirect: "/",
  },
]

const routesPhone = [
  {
    path: '/',
    component: () => import('./phone/index.vue'),
  },
  {
    path: '/secondList',
    name: 'secondList',
    component: () => import('./phone/secondList.vue')
  },
  {
    path: "/detailsPhone",
    name: 'detailsPhone',
    component: () => import('./phone/detailsPhone.vue')
  },
  {
    path: '/classification',
    name: 'classification',
    component: () => import('./phone/classification.vue')
  },
  {
    path: "/searchPhone",
    name: 'searchPhone',
    component: () => import('./phone/searchPhone.vue')
  },
  {
    path: "/more",
    name: 'more',
    component: () => import('./phone/more.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('./phone/contact.vue')

  },
  {
    path: "/:patchAll(\\S+)",
    redirect: "/",
  },
]
if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
  // 当前设备是移动设备
  console.log('当前设备是移动设备');
  ismobi = true
} else {
  ismobi = false
}
const router = createRouter({
  // 路由的模式
  history: createWebHistory(),
  // 路由规则
  routes: ismobi ? routesPhone : routes,
})

router.beforeEach((to, from, next) => {
  // 让页面回到顶部
  // chrome
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  // safar
  window.pageYOffset = 0;
  next()
})


// router.beforeEach((to, from, next) => {
//   let arr = to.path.split('/')
//   if (to.path === '/') return next();
//   if (to.path === '/qrcode/invalid') return next();
//   if (to.path === '/download') return next();
//   if (to.path === '/mlogin') return next();
//   if (arr && arr.includes('miniapp')) return next();
//   if (to.path === '/download.html') return next();
//   //获取token
//   const tokenStr = window.localStorage.getItem('token')
//   //如果没有获取到token那么返回登录
//   if (!tokenStr) return next('/mlogin')
//   //得到token就跳转页面，放行
//   next()
// })


export default router
